import { UserOutlined } from "@ant-design/icons";
import { Avatar, List } from "antd";
import { Box } from "components/base";
import { ISSOUser } from "pages/Auth/services/typings";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "themes/styled";
import UserItem from "./UserItem";

interface Props {
  data?: ISSOUser[];
  onItemClick?: (item: ISSOUser, loggedOut?: boolean) => void;
  onUseAnotherAccountClick?: () => void;
}

const UserList: React.FC<Props> = (props) => {
  const { data, onItemClick, onUseAnotherAccountClick } = props;
  const { t } = useTranslation();
  return (
    <Box py={[3]} maxHeight={350} overflowX="auto">
      <StyledList
        itemLayout="horizontal"
        dataSource={data}
        bordered
        renderItem={(user: ISSOUser) => (
          <UserItem data={user} onItemClick={onItemClick} />
        )}
        footer={
          <StyledItem
            onClick={() =>
              !!onUseAnotherAccountClick && onUseAnotherAccountClick()
            }
          >
            <List.Item.Meta
              avatar={<Avatar icon={<UserOutlined />} />}
              title={<b>{t("auth.login.use_another_account")}</b>}
              description={t("auth.login.use_another_account_desc")}
            />
          </StyledItem>
        }
      />
    </Box>
  );
};

const StyledList = styled(List)`
  .ant-list-footer {
    padding: 0px !important;
  }
` as any as typeof List;

const StyledItem = styled(List.Item)`
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.hover_color};
  }
`;

export default UserList;
